import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { FaSave } from 'react-icons/fa';
import { ResultsSectionProps } from '../types/types';

const ResultsSection: React.FC<ResultsSectionProps> = ({
  results,
  formatNumber,
  formatCurrency
}) => {
  const SaveIcon: React.FC<{ className?: string }> = ({ className }) => {
    const IconComponent = FaSave as any;
    return <IconComponent className={className} />;
  };
  return (
    <div id="results-section" className="results-section">
      <Row>
        <Col lg={6}>
          <Card className="results-block hoc-results">
            <Card.Header as="h2">HOC RESULTS</Card.Header>
            <Card.Body>
              <Row>
                <Col md={6}>
                  <p>
                    <strong>Cap Total Hours:</strong>{' '}
                    {formatNumber(results.hoc.capHours)}
                  </p>
                  <p>
                    <strong>Salt Total Hours:</strong>{' '}
                    {formatNumber(results.hoc.saltHours)}
                  </p>
                  <p>
                    <strong>Total HO Hours:</strong>{' '}
                    {formatNumber(results.hoc.totalHours)}
                  </p>
                  <p>
                    <strong>Viper Tools Required:</strong>{' '}
                    {formatNumber(results.hoc.viperTools)}
                  </p>
                  <p>
                    <strong>RHO Tools Required:</strong>{' '}
                    {formatNumber(results.hoc.rhoTools)}
                  </p>
                </Col>
                <Col md={6}>
                  <p>
                    <strong>Tool Costs:</strong>{' '}
                    {formatCurrency(results.hoc.toolCosts)}
                  </p>
                  <p>
                    <strong>Trip Costs:</strong>{' '}
                    {formatCurrency(results.hoc.tripCosts)}
                  </p>
                  <p>
                    <strong>Drill Hours Cost:</strong>{' '}
                    {formatCurrency(results.hoc.drillHoursCost)}
                  </p>
                  <p className="total-cost">
                    <strong>Total Cost:</strong>{' '}
                    {formatCurrency(results.hoc.totalCost)}
                  </p>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={6}>
          <Card className="results-block competitor-results">
            <Card.Header as="h2">CONVENTIONAL RESULTS</Card.Header>
            <Card.Body>
              <Row>
                <Col md={6}>
                  <p>
                    <strong>Cap Total Hours:</strong>{' '}
                    {formatNumber(results.competitor.capHours)}
                  </p>
                  <p>
                    <strong>Salt Total Hours:</strong>{' '}
                    {formatNumber(results.competitor.saltHours)}
                  </p>
                  <p>
                    <strong>Total HO Hours:</strong>{' '}
                    {formatNumber(results.competitor.totalHours)}
                  </p>
                  <p>
                    <strong>Conventional Tools Required:</strong>{' '}
                    {formatNumber(results.competitor.convTools)}
                  </p>
                </Col>
                <Col md={6}>
                  <p>
                    <strong>Tool Costs:</strong>{' '}
                    {formatCurrency(results.competitor.toolCosts)}
                  </p>
                  <p>
                    <strong>Trip Costs:</strong>{' '}
                    {formatCurrency(results.competitor.tripCosts)}
                  </p>
                  <p>
                    <strong>Drill Hours Cost:</strong>{' '}
                    {formatCurrency(results.competitor.drillHoursCost)}
                  </p>
                  <p className="total-cost">
                    <strong>Total Cost:</strong>{' '}
                    {formatCurrency(results.competitor.totalCost)}
                  </p>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Card className="savings-summary mt-4">
        <Card.Header as="h2">
          <SaveIcon className="me-2" /> Cost Savings Summary
        </Card.Header>
        <Card.Body className="text-center">
          <div
            className={
              results.savings > 0 ? 'positive-savings' : 'negative-savings'
            }
          >
            <h3>
              {results.savings > 0
                ? `HOC optimization provides a savings of ${formatCurrency(
                    results.savings
                  )}`
                : `HOC solution costs ${formatCurrency(
                    Math.abs(results.savings)
                  )} more than conventional approach`}
            </h3>
            <p>
              {results.savings > 0
                ? `That's ${formatNumber(
                    results.percentageSavings
                  )}% less than the conventional approach`
                : `That's ${formatNumber(
                    Math.abs(results.percentageSavings)
                  )}% more than conventional approach`}
            </p>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ResultsSection;
